package `fun`.adaptive.adaptive_lib_document.generated.resources

import `fun`.adaptive.resource.string.Strings
import `fun`.adaptive.resource.string.StringStoreResourceSet
import `fun`.adaptive.resource.file.FileResource

val commonMainStringsStringStore0 =
    StringStoreResourceSet(
        name = "strings",
        FileResource("/fun.adaptive.adaptive_lib_document.generated.resources/strings/strings.avs", setOf())
    )

val Strings.documentation
    get() = commonMainStringsStringStore0.get(0)